import { jsx as _jsx } from "react/jsx-runtime";
import AnalyticsLogo from "./logos-svg/analytics.js";
import Care4Logo from "./logos-svg/care4.js";
import DataStationLogo from "./logos-svg/data-station.js";
import DigitalCareLogo from "./logos-svg/digital-care.js";
import EcdVvtLogo from "./logos-svg/ecd-vvt.js";
import HrSalaryAdminLogo from "./logos-svg/hr-salary-admin.js";
import HrLogo from "./logos-svg/hr.js";
import IdentityLogo from "./logos-svg/identity.js";
import KisLogo from "./logos-svg/kis.js";
import LearningLogo from "./logos-svg/learning.js";
import OctopusLogo from "./logos-svg/octopus.js";
import OneLogo from "./logos-svg/one.js";
import PlanningLogo from "./logos-svg/planning.js";
import SalaryLogo from "./logos-svg/salary.js";
import UserLogo from "./logos-svg/user.js";
export const ProductLogoAtomComponent = ({ type, width = 40, height = 40 }) => {
    switch (type) {
        case "care4":
            return _jsx(Care4Logo, { "data-testid": "Care4Logo", width: width, height: height });
        case "digital-care":
            return _jsx(DigitalCareLogo, { "data-testid": "DigitalCareLogo", width: width, height: height });
        case "ecd-vvt":
            return _jsx(EcdVvtLogo, { "data-testid": "EcdVvtLogo", width: width, height: height });
        case "hr":
            return _jsx(HrLogo, { "data-testid": "HrLogo", width: width, height: height });
        case "learning":
            return _jsx(LearningLogo, { "data-testid": "LearningLogo", width: width, height: height });
        case "planning":
            return _jsx(PlanningLogo, { "data-testid": "PlanningLogo", width: width, height: height });
        case "salary":
            return _jsx(SalaryLogo, { "data-testid": "SalaryLogo", width: width, height: height });
        case "analytics":
            return _jsx(AnalyticsLogo, { "data-testid": "AnalyticsLogo", width: width, height: height });
        case "analytics-budget":
            return _jsx(AnalyticsLogo, { "data-testid": "AnalyticsBudget", width: width, height: height });
        case "one":
            return _jsx(OneLogo, { "data-testid": "OneLogo", width: width, height: height });
        case "identity":
            return _jsx(IdentityLogo, { "data-testid": "IdentityLogo", width: width, height: height });
        case "hr-salary-admin":
            return _jsx(HrSalaryAdminLogo, { "data-testid": "HrSalaryAdminLogo", width: width, height: height });
        case "kis":
            return _jsx(KisLogo, { "data-testid": "KisLogo", width: width, height: height });
        case "data-station":
            return _jsx(DataStationLogo, { "data-testid": "DataStationLogo", width: width, height: height });
        case "user":
            return _jsx(UserLogo, { "data-testid": "UserLogo", width: width, height: height });
        case "octopus":
            return _jsx(OctopusLogo, { "data-testid": "OctopusLogo", width: width, height: height });
        default:
            console.error(`You've entered an invalid application type: ${String(type)}`);
            return _jsx("div", { style: { width, height } });
    }
};
export default ProductLogoAtomComponent;
